<script>

import HeaderAdmin from '@/components/header/HeaderAdmin.vue'
export default {
  name: 'AdminApp',
  components: { HeaderAdmin }
}
</script>

<template>
  <div>
    <header-admin />
    <div class="p-4 md:ml-64 h-auto pt-20">
      <slot />
    </div>
  </div>
</template>

<style scoped>

</style>